import { Component, ViewChild } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { Logger } from 'app/core/logger.service';
import * as Models from 'app/core/models';

const log = new Logger('App');
@Component({
    selector: 'app-forgot-password-modal',
    templateUrl: './forgotPasswordModal.component.html',
    styleUrls: ['./forgotPasswordModal.component.scss']
})

export class ForgotPasswordModalComponent implements Models.ModalComponent {

    @ViewChild('modalForgotPassword') public contentModal: any;

    version: string = environment.version;
    error: any = null;
    forgetPassowrdForm: FormGroup;
    isLoading = false;
    showForm = true;
    showSuccessMessage = false;

    constructor(private formBuilder: FormBuilder, private authenticationService: AuthenticationService,
                private translateService: TranslateService) {
        this.createForm();
    }

    reset() {
        this.forgetPassowrdForm.reset();
        this.showSuccessMessage = false;
        this.showForm = true;
    }

    sendResetLink() {
        this.isLoading = true;
        this.authenticationService.forgotPassword(this.forgetPassowrdForm.value)
            .finally(() => {
                if (!this.error) {
                    this.forgetPassowrdForm.markAsPristine();
                    this.forgetPassowrdForm.reset();
                }
                this.isLoading = false;
            })
            .subscribe(credentials => {
                log.debug(`successfully sent forgot password`);
                this.error = undefined;
                this.showForm = false;
                this.showSuccessMessage = true;
            }, error => {
                log.debug(`forgot password error: ${error}`);
                this.error = error;
            });
    }

    get errorMessage(): string {
        if (this.error) {
            const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
            if (errorBody && errorBody.error) {
              return errorBody.error;
            }
        }
      this.translateService.get('AUTH.FORGOT_PASSWORD.GENERAL_ERROR').subscribe((translatedErrMsg) => {
        return translatedErrMsg;
      });
    }

    openModal() {
        this.reset();
        this.contentModal.show();
    }

    closeModal() {
        this.contentModal.hide();
    }

    private createForm() {
        this.forgetPassowrdForm = this.formBuilder.group({
            email: ['', Validators.email]
        });
    }
}




// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/forgotPassword/forgotPasswordModal.component.ts